<script setup lang="ts">
import HeaderDefault from "./header/index.vue";
import MenuDefault from "./menu/index.vue";
</script>

<template>
    <div class="app-container">
        <HeaderDefault />
        <main class="container">
            <MenuDefault v-if="!$route.meta.hideMenu" />
            <div class="main-container-body">
               <router-view />
            </div>
        </main>
    </div>
</template>

<style scoped lang="scss">
.app-container {
    height: 100vh;
    box-sizing: border-box;
    background: linear-gradient(180deg, #f0f6ff 0%, #fafbfc 49.5%);
    .container {
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        padding: 16px 0 16px 16px;
        box-sizing: border-box;
    }

    .main-container-body {
        flex: 1;
        flex-shrink: 0;
        min-width: 0;
        padding: 0 16px;
        box-sizing: border-box;
    }
}

// @media (min-width: 1440px) {
//     .app-container {
//         width: 100%;
//         overflow-x: hidden;
//     }
// }
</style>
